<template>
  <div id="download-banner">
    <div class="vertical-middle describe-box">
      <h2>{{ $t('downloadVpn') }}{{ currentDownloadInfo.name === 'Ubuntu' ? 'Linux' : currentDownloadInfo.name }}{{ $t('clientInfo') }}</h2>

      <div class="describe">
        <template v-if="currentPlatform === 'windows'">
          <div class="row">
            <div class="col-xs-12 col-sm-6">
              <p>{{ $t('support') }}{{ $t(':') }}{{ windows.support }}</p>
              <p>{{ $t('version') }}{{ $t(':') }}{{ windows.downloadInfo.version_name }}</p>
              <p>{{ $t('fileSize') }}{{ $t(':') }}{{ windows.downloadInfo.file_size | fileSize }}MB</p>
              <p>{{ $t('updateTime') }}{{ $t(':') }}{{getExpiredTime(windows.downloadInfo.last_updated_at)}}</p>
            </div>
          </div>
        </template>

        <template v-if="currentPlatform === 'mac'">
          <p>{{ $t('support') }}{{ $t(':') }}{{ mac.support }}</p>
          <p>{{ $t('version') }}{{ $t(':') }}{{ mac.downloadInfo.version_name }}</p>
          <p>{{ $t('fileSize') }}{{ $t(':') }}{{ mac.downloadInfo.file_size | fileSize }}MB</p>
          <p>{{ $t('updateTime') }}{{ $t(':') }}{{getExpiredTime(mac.downloadInfo.last_updated_at)}}</p>
        </template>

        <template v-if="currentPlatform === 'ios'">
          <p>{{ $t('support') }}{{ $t(':') }}{{ ios.support }}</p>
          <p>{{ $t('version') }}{{ $t(':') }}{{ ios.downloadInfo.version_name }}</p>
          <p>{{ $t('updateTime') }}{{ $t(':') }}{{getExpiredTime(ios.downloadInfo.last_updated_at)}}</p>

          <div v-if="language === 'zh'" class="apple-account-tips">
            <p>部分地区 App Store 不支持 PlexVPN 下载，请 <router-link to="/region-tutorial-iOS">修改自己 Apple ID 的所属地区</router-link> 进行下载</p>
          </div>
        </template>

        <template v-if="currentPlatform === 'android'">
          <p>{{ $t('support') }}{{ $t(':') }}{{ android.support }}</p>
          <p v-show="android.downloadInfo.version_name">{{ $t('version') }}{{ $t(':') }}{{ android.downloadInfo.version_name }}</p>
          <p>{{ $t('fileSize') }}{{ $t(':') }}{{ android.downloadInfo.file_size | fileSize }}MB</p>
          <p>{{ $t('updateTime') }}{{ $t(':') }}{{getExpiredTime(android.downloadInfo.last_updated_at)}}</p>
        </template>

        <template v-if="currentPlatform === 'androidTV'">
          <p>{{ $t('support') }}{{ $t(':') }}{{ androidTV.support }}</p>
          <p v-show="androidTV.downloadInfo.version_name">{{ $t('version') }}{{ $t(':') }}{{ androidTV.downloadInfo.version_name }}</p>
          <p>{{ $t('fileSize') }}{{ $t(':') }}{{ androidTV.downloadInfo.file_size | fileSize }}MB</p>
          <p>{{ $t('updateTime') }}{{ $t(':') }}{{getExpiredTime(androidTV.downloadInfo.last_updated_at)}}</p>
        </template>

        <template v-if="currentPlatform === 'ubuntu'">
          <p>{{ $t('support') }}{{ $t(':') }}{{ ubuntu.support }}</p>
          <p>{{ $t('version') }}{{ $t(':') }}{{ ubuntu.downloadInfo.version_name }}</p>
          <p>{{ $t('fileSize') }}{{ $t(':') }}{{ ubuntu.downloadInfo.file_size | fileSize }}MB</p>
          <p>{{ $t('updateTime') }}{{ $t(':') }}{{getExpiredTime(ubuntu.downloadInfo.last_updated_at)}}</p>
        </template>

      </div>

      <p class="notice" v-if="currentPlatform === 'windows'">{{ $t('requirementsNotice') }}</p>

      <download-btn></download-btn>
    </div>
    <div class="vertical-middle img-box" :class="{'android-or-ios': currentPlatform === 'android' || currentPlatform === 'ios', 'androidTV': currentPlatform === 'androidTV'}">
      <template v-for="(item, index) in [windows, android, mac, ios, ubuntu, androidTV]">
        <img v-if="item.imgUrl === currentDownloadInfo.imgUrl" :class="item.name" v-bind:src="item.imgUrl" v-bind:key="index"/>
      </template>
    </div>
  </div>
</template>

<script>
  import locales from './lang'
  import DownloadBtn from '../downloadBtn/DownloadBtn.vue'
  import Triangle from '../../triangle/Triangle.vue'
  import { mapState } from 'vuex'
  import { formatTime } from 'src/lib/filters'

  export default {
    name: 'download-banner',
    locales,
    components: { DownloadBtn, Triangle },
    data: function () {
      return {
        downloadNetLink: process.env.DOWNLOAD_NET_LINK,
        appleAccounts: ''
      }
    },
    computed: {
      currentDownloadInfo() {
        return this.$store.state.download[this.currentPlatform]
      },
      ...mapState({
        downloadInfo: state => state.download,
        currentPlatform: state => state.download.currentPlatform,
        windows: state => state.download.windows,
        windowsWpf: state => state.download.windowsWpf,
        mac: state => state.download.mac,
        ios: state => state.download.ios,
        android: state => state.download.android,
        androidTV: state => state.download.androidTV,
        ubuntu: state => state.download.ubuntu,
        language: state => state.currentLang
      })
    },
    created() {
      this.getAppleAccounts()
    },
    methods: {
      getExpiredTime(last_updated_at) {
        if (last_updated_at) {
          return formatTime(last_updated_at * 1000).split(' ')[0]
        } else {
          return ''
        }
      },
      getAppleAccounts() {
        this.$http.get('api/ios/apple-account').then((response) => {
          if (response.data.code === 0) {
            this.appleAccounts = response.body.data
          }
        })
      }
    },
    filters: {
      fileSize: function (fileSize) {
        return fileSize > 0 ? (fileSize / 1024 / 1024).toFixed(2) : 0
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "./downloadBanner";
</style>



// WEBPACK FOOTER //
// DownloadBanner.vue?b1edb30a